import {
    getBbClientState,
    setBbClientState,
    bbClientStateSubscribe,
} from './bb-client-state';

export const STATE_INIT_STATE_KEY = 'state:init';
export const STATE_INIT_FAILED_STATE_KEY = 'state:init:failed';

/**
 * Gets a value from bbClientState
 * @param  {String} key the for the value
 * @return {*} the value stored in bbClientState
 */
export const getState = (key) => getBbClientState(key);

/**
 * Sets a value to bbClientState
 * @param  {String} key the for the value
 * @param  {*} value the value for the key
 * @return {void}
 */
export const setState = (key, value) => setBbClientState(key, value);

/**
 * Subscribes to bbClientState
 * @param  {String|Function}   key  The key to listen or the callback function
 * @param  {Function} [callback] optional calback function if the key is given
 * @return {Function} a function to easily unsubscribe
 */
export const subscribeToStateChange = (key, callback) => bbClientStateSubscribe(key, callback);

/**
 *Register a callback for when the state is initialized
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onStateInitialized = (callback) => {
    return subscribeToStateChange(STATE_INIT_STATE_KEY, callback);
};

/**
 *Register a callback for when the state initialization failed
 * @param {Function} callback The callback function
 * @return {Function} An unsubscribe function
 */
export const onStateInitializationFail = (callback) => {
    return subscribeToStateChange(STATE_INIT_FAILED_STATE_KEY, callback);
};

/**
 * Checks if state has been initialized
 * @return {Boolean} Returns true if initilaized
 */
export const isStateInitialized = () => Boolean(getState(STATE_INIT_STATE_KEY));
